import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
    name: 'auth/session',
    initialState: {
        otpToken: '',
        token: '',
        signedIn: false,
    },
    reducers: {
        setOtpToken: (state, action) => {
            state.otpToken = action.payload
        },
        onSignInSuccess: (state, action) => {
            state.signedIn = true
            state.token = action.payload
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.token = ''
        },
        setToken: (state, action) => {
            state.token = action.payload
        },
    },
})

export const { onSignInSuccess, onSignOutSuccess, setOtpToken, setToken } =
    sessionSlice.actions

export default sessionSlice.reducer
